<template>
  <div class="slide html-frame">
    <iframe
      v-if="data.html_url"
      :src="data.html_url"
      class="frame"
      sandbox="allow-scripts allow-same-origin"
      referrerpolicy="no-referrer"
      loading="eager"
    ></iframe>
    <div v-else class="placeholder">
      No HTML file attached — drop one in the slide editor.
    </div>
  </div>
</template>

<script>
export default {
  name: 'HtmlFrame',
  props: {
    data: { type: Object, required: true },
    config: { type: Object, default: () => ({}) }
  }
}
</script>

<style scoped>
.slide {
  width: 1920px;
  height: 1080px;
  background: #000;
  position: relative;
}
.frame {
  width: 1920px;
  height: 1080px;
  border: 0;
  display: block;
}
.placeholder {
  width: 1920px;
  height: 1080px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 36px;
  font-family: Inter, system-ui, sans-serif;
}
</style>
